import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Packages
import { Button, Space, Spin, Table, Tag, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Utils
import { get_load_source_desc, get_load_status_desc, get_load_type_desc } from '../../../utils/get_status_desc';
import { get_load_status_color } from '../../../utils/get_color_status';

const LoadFilesTable = (props) => {
	const { onConfirm, onDiscard, loadId, isWizardContext = false } = props;
	
	const { t } = useTranslation();
	
	const { all_files_loading, all_files, file_confirm_loading, file_discard_loading } = useSelector(state => state.self);
	
	const columns = [
		{
			title: t('routesTable.headers.name'),
			dataIndex: 'name',
			key: 'name',
			render: (_, record) => (
				<Typography.Text copyable={{ text: record._id.$oid, tooltips: [t('copyableText.copyId'), t('copyableText.copiedId')] }}>
					{record.name}
				</Typography.Text>
			)
		},
		{
			title: t('loadFileInput.description'),
			dataIndex: 'description',
			key: 'description'
		},
		{
			title: t('loadFileInput.loadType'),
			dataIndex: 'load_type',
			key: 'load_type',
			render: (text) => (
				<Typography.Text>{get_load_type_desc(text)}</Typography.Text>
			)
		},
		{
			title: t('loadStatusDetails.card.source'),
			dataIndex: 'source',
			key: 'source',
			render: (text) => (
				<Typography.Text>{get_load_source_desc(text)}</Typography.Text>
			)
		},
		{
			title: t('routesTable.headers.status'),
			dataIndex: 'status',
			key: 'status',
			render: (_, record) => (
				<Tag color={get_load_status_color(record?.status)}>{get_load_status_desc(record?.status)}</Tag>
			)
		},
		{
			title: t('loadStatus.statusTable.date'),
			dataIndex: ['date', '$date'],
			key: 'date',
			render: (text) => (
				<Typography.Text>{new Date(text).toLocaleString(localStorage.getItem('i18nextLng'), { hour12: true })}</Typography.Text>
			)
		},
		{
			title: t('routesTable.headers.action'),
			dataIndex: 'action',
			key: 'action',
			render: (_, record) => (
				<Space>
					<Link to={isWizardContext ? `/wizard/status/file=${record._id.$oid}` : `/load-file/${record._id.$oid}/info`}>
						<Tooltip title={t('loadStatus.statusTable.actionButtons.details')}>
							<Button
								type='primary'
								shape='circle'
								size='large'
								icon={<span className='material-symbols-outlined'>visibility</span>}
							/>
						</Tooltip>
					</Link>
					{record?.status === 3 &&
						<Space>
							<Tooltip title={t('loadStatus.statusTable.actionButtons.confirm')}>
								<Button
									type='primary'
									shape='circle'
									size='large'
									className='success-btn'
									icon={<span className='material-symbols-outlined'>check_circle</span>}
									loading={file_confirm_loading}
									onClick={() => onConfirm(record)}
								/>
							</Tooltip>
							<Tooltip title={t('loadStatus.statusTable.actionButtons.discard')}>
								<Button
									type='primary'
									shape='circle'
									size='large'
									danger
									icon={<span className='material-symbols-outlined'>cancel</span>}
									loading={file_discard_loading}
									onClick={() => onDiscard(record)}
									style={{ 
										backgroundColor: '#ff4d4f',
										borderColor: '#ff4d4f',
										color: 'white'
									}}
								/>
							</Tooltip>
						</Space>
					}
				</Space>
			)
		}
	];
	
	return (
		<Spin spinning={all_files_loading} tip={t('loadStatus.statusTable.loading')} size='large'>
			<Table
				columns={columns}
				dataSource={all_files.files}
				pagination={false}
				scroll={{
					x: 1000
				}}
			/>
		</Spin>
	);
}

LoadFilesTable.propTypes = {
	onConfirm: PropTypes.func.isRequired,
	onDiscard: PropTypes.func.isRequired,
	loadId: PropTypes.string,
	isWizardContext: PropTypes.bool
}

export default LoadFilesTable;